import { Component, ViewChild } from '@angular/core';
import { MerchantTableViewComponent } from '../../components/merchant/merchant-table-view/merchant-table-view.component';
import { StorageService } from '../../core/storage/storageService';
import { Merchant } from '../../models/merchant/merchant';
import { Account } from '../../models/account/account';
import { AccountService } from '../../models/account/accountService';
import { Options } from '../../components/ui/filterable-table/options';
import { TableView } from '../../components/ui/filterable-table/tableView';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  standalone: false,
})
export class MyAccountComponent {
  @ViewChild('merchantTable') merchantTableControl:
    | MerchantTableViewComponent
    | undefined;

  toggleTableOn: boolean = false;

  selectedMerchant: Merchant | undefined;

  merchantTableOptions: Options = new Options({
    selectAction: 'expand',
  });

  merchantTableView: any;

  constructor(
    private storage: StorageService,
    private accountService: AccountService,
    private router: Router,
  ) {
    if (!this.storage.getMyAccount()) {
      this.router.navigate(['/merchant/account']);
    }
    this.selectedMerchant = this.storage.getSelectedLocation();

    this.merchantTableOptions = new Options({
      selectAction: 'expand',
    });

    this.merchantTableView = new TableView(MerchantTableViewComponent);

    if (!this.selectedMerchant) {
      //throw "my-account: no selected merchant";
    }
  }

  setupLocationTableOptions(myAccount: Account) {
    if (myAccount) {
      this.merchantTableOptions.accountId = myAccount.id;
    } else {
      if (this.storage.getNumberOfMyBusinesses() <= 1) {
        this.merchantTableOptions.filterable = false;
      }
    }
    this.merchantTableOptions.accountId = myAccount.id;
    this.merchantTableOptions.selectRoute = 'my-account';
    this.merchantTableControl?.setOptions(this.merchantTableOptions);
  }

  ngAfterViewInit() {
    let usr = this.storage.getCurrentUser();

    let myAccount = this.storage.getMyAccount();

    if (this.storage.getSelectedLocation()) {
      if (!myAccount) {
        let accountId = this.storage.getSelectedLocation()?.accountId;
        if (accountId) {
          this.accountService.getAccount(accountId).then((account) => {
            this.setupLocationTableOptions(account);
          });
        } else {
          // this won't ever happen since every location is associated with a business
        }
      }
    }

    this.setupLocationTableOptions(this.storage.getMyAccount() as Account);
  }

  handle_selectedMerchant(merchant: Merchant) {
    this.selectedMerchant = this.storage.getSelectedLocation();
    this.merchantTableView = new TableView(MerchantTableViewComponent);
    this.toggleTableOn = false;
    this.ngAfterViewInit();
    this.storage.setShowSupportInfo(true);
  }
}
